// Espaces, caractères de contrôle (C0/C1, DEL) et antislash : jamais dans un lien suivi.
// eslint-disable-next-line no-control-regex
const FORBIDDEN_CHARS = /[\u0000- \u007f-\u009f\\]/;

/**
 * F-40 — Garde des liens saisis par un admin (carousel `link_url`).
 * Même règle que le serveur (backend/src/utils/safe-url.util.js) : seulement un chemin
 * interne `/…` (pas `//hote`) ou une URL `https:`. Neutralise aussi les lignes
 * enregistrées avant le contrôle serveur (javascript:, data:, http:…).
 *
 * @param {unknown} url
 * @returns {{ internal: boolean, href: string } | null} null si le lien doit être ignoré
 */
export function safeHref(url) {
  if (typeof url !== 'string' || url === '' || url.length > 2048) return null;
  if (FORBIDDEN_CHARS.test(url)) return null;

  if (url.startsWith('/')) {
    return url.startsWith('//') ? null : { internal: true, href: url };
  }

  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'https:' && parsed.hostname) return { internal: false, href: url };
  } catch {
    // URL non analysable : ignorée
  }
  return null;
}
